import ErrorsConstants from '../../constants/ErrorsConstants';
var initialState = {
  incorrectEntities: {
    text: '',
    validation: true
  }
};

export default function errors(state = initialState, action) {
  switch (action.type) {
    case ErrorsConstants.INCORRECT_ENTITIES:
      return {
        ...state,
        incorrectEntities: {
          text: action.payload,
          validation: false
        }
      };
    case ErrorsConstants.RESET_VALIDATION_STATUS:
      var error = state[action.payload] = {
        ...state[action.payload],
        validation: true
      };
      return {
        ...state,
        error
      };
    default:
      break;
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducers/data/errors.js
 **/